import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { useRequirementDefinitionsSettings } from "./useRequirementDefinitionsSettings";
import { useRequirementDefinitionListAllQuery } from "./useRequirementDefinitionListAllQuery";
import { ExtendedRequirementDefinition } from "./useExtendedRequirementDefinition";

export const QUERY_EXTENDED_REQUIREMENT_DEFINITIONS =
  "QUERY_EXTENDED_REQUIREMENT_DEFINITIONS";

export const useExtendedRequirementDefinitions = (
  fetch: Parameters<typeof useRequirementDefinitionsSettings>[0]["fetch"]
) => {
  const queryRequirements = useRequirementDefinitionListAllQuery();
  const querySettings = useRequirementDefinitionsSettings({
    enabled: queryRequirements.isSuccess,
    requirementDefinitions: queryRequirements.data || [],
    fetch
  });

  return useWSQuery<ExtendedRequirementDefinition[], WSServiceError>(
    [
      QUERY_EXTENDED_REQUIREMENT_DEFINITIONS,
      fetch,
      queryRequirements.dataUpdatedAt
    ],
    () => {
      const requirements = queryRequirements.data || [];
      const extendedRequirements = requirements.map(requirement => ({
        ...requirement,
        dataSource: querySettings.data?.[requirement.dataSourceId!]
      }));

      return Promise.resolve(extendedRequirements);
    },
    {
      enabled: queryRequirements.isSuccess && querySettings.isFetched
    }
  );
};
